import { useEffect } from 'preact/hooks';
import { activeChatId, openChat, session } from '../lib/engine.js';
import { initHistory, view } from './nav.js';
import { Auth } from './Auth.js';
import { ChatList } from './ChatList.js';
import { ChatView } from './ChatView.js';
import { ChatInfo } from './ChatInfo.js';
import { NewChat } from './NewChat.js';
import { Settings } from './Settings.js';

export function App() {
  // Один раз за жизнь приложения: связывает экраны с историей браузера,
  // чтобы системный жест «назад» возвращал к списку, а не закрывал приложение.
  useEffect(() => {
    initHistory();
  }, []);

  useEffect(() => {
    // Переход из уведомления: /?chat=<id> открывает нужный чат сразу.
    const chatId = new URL(location.href).searchParams.get('chat');
    if (chatId && session.value) {
      void openChat(chatId).then(() => {
        view.value = 'chat';
      });
    }
  }, [session.value?.userId]);

  if (!session.value) return <Auth />;

  switch (view.value) {
    case 'chat':
      return activeChatId.value ? <ChatView /> : <ChatList />;
    case 'chat-info':
      return activeChatId.value ? <ChatInfo /> : <ChatList />;
    case 'new-chat':
      return <NewChat />;
    case 'settings':
      return <Settings />;
    default:
      return <ChatList />;
  }
}
